import React from 'react'
import { BlogLanding } from '../../pages'


const BlogLandingContainer = () => {
  return (
    <BlogLanding />
  )
}

export default BlogLandingContainer